"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var lauterbad_common_1 = require("@eimerreis/lauterbad-common");
var StyledImage = styled_components_1["default"].img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n    margin-top: ", "px;\n    margin-left: ", "px;\n    margin-bottom: ", "px;\n"], ["\n    width: ", ";\n    height: ", ";\n    margin-top: ", "px;\n    margin-left: ", "px;\n    margin-bottom: ", "px;\n"])), function (props) { return props.width ? props.width + "px" : "auto"; }, function (props) { return props.height ? props.height + "px" : "auto"; }, function (props) { return props.MarginTop || "0"; }, function (props) { return props.MarginLeft || "0"; }, function (props) { return props.MarginBottom || "0"; });
exports.Image = function (props) {
    if (props.blok.Link) {
        // if external link => add target blank to link
        var linkProps = !lauterbad_common_1.IsInternalLink(props.blok.Link.cached_url) ? {
            rel: "noopener",
            target: "_BLANK"
        } : {};
        return (React.createElement("a", __assign({}, linkProps, { href: props.blok.Link.cached_url }),
            React.createElement(StyledImage, __assign({}, props.blok, { src: props.blok.image }))));
    }
    return (React.createElement(StyledImage, __assign({}, props.blok, { src: props.blok.image })));
};
var templateObject_1;
